import { EncounterInfo } from "./common/EncounterInfo";
import axios from "axios";
import { tidyLocation2, getAllChildren, isTooth, getOnlyFullTeeth } from "react-lib/apps/common/CUDENT/DentalRecordUtil";
import { WasmHandler } from "react-lib/frameworks/WasmController";
import { TreatmentPlanState } from "./TreatmentTodayInterface";
import DentalExaminationDetail from "issara-sdk/apis/DentalExaminationDetail_apps_DEN";
import DentalExaminationDetailM from "issara-sdk/apis/DentalExaminationDetail_apps_DENM";
import DentalExaminationList from "issara-sdk/apis/DentalExaminationList_apps_DEN";
import DentalMedicalHistoryList from "issara-sdk/apis/DentalMedicalHistoryList_apps_DEN";
import CONFIG from "config/config";
// import ClinicalFindings from "./ClinicalFindingsUX";
import DentalClinicalFindingHotKeyList from "issara-sdk/apis/DentalClinicalFindingHotKeyList_apps_DEN";
import DentalClinicalFindingHotKeyDetail from "issara-sdk/apis/DentalClinicalFindingHotKeyDetail_apps_DEN";
import DentalMedicalHistoryByEncounterDetail from "issara-sdk/apis/DentalMedicalHistoryByEncounterDetail_apps_DEN";
import DentalMedicalHistoryDetail from "issara-sdk/apis/DentalMedicalHistoryDetail_apps_DEN";
import DentalMedicalHistoryApproveDetail from "issara-sdk/apis/DentalMedicalHistoryApproveDetail_apps_DEN";

import { formatDate } from "react-lib/utils";
import moment from "moment";
import { deTinyLocation2 } from "react-lib/apps/common/CUDENT/DentalRecordUtil";

const HOST = `${CONFIG.API_HOST}`;

const tissueMapPane = {
  primary_teeth: "baby_tooth",
  permanent_teeth: "tooth",
  face: "Head & Neck",
  muscle: "Muscle & TMJ",
  periodontium: "Periodontium",
  soft: "Oral cavity",
  jaw: "Jaw-bones",
  odontogram: "Odontogram",
};

export const MissingToothClinical = ["Clinical absence", "Congenital absence", "Extracted tooth", "Unerupted tooth"];
export const PartialMissingToothClinical = ["Partial eruption"];

export type DiagnosisState = {
  encounterList?: EncounterInfo[];

  // DPOI
  openModalReExamination?: boolean;
  reExaminationSub: string;
  reExamEncounterList?: any[];
  allReExamEncounterList?: any[];

  // PatientInfoI
  patientDetail?: any;

  //
  encounterIndex?: number | null;
  clinicalFindingList?: any[];
  clinicalFindingIndex?: number | null;
  doctorProfileData?: any;
  openModCancelTreatmentPlan?: any;
  // clinical;
  treatmentPlanList?: TreatmentPlanState[];
  encounterInfo?: EncounterInfo;
  clinicalFindings?: any[];
  selectorMode?: boolean;
  // openGallery?: {
  //   open: boolean;
  //   activeTabs: string[];
  //   imageOverlayData: any[];
  //   hideBabyTooth: boolean;
  // };
  showDrawingChecked?: string[];
  showDrawingCheckedAll?: boolean;
  // editRow?: number;
  openModRemoveClinicalFinding?: {
    open: boolean;
    id: any;
    title: string;
  };
  muscleExamData?: any;
  softTissueExamData?: any;
  faceExamData?: any;
  dentalExamData?: any;
  periodontalExamData?: any;
  medicalHistoryList?: {
    id?: any;
    edit_user?: any;
    created?: any;
    edited?: any;
    encounter?: any;
    chief_complaints?: any;
    present_illness?: any;
    additional_comment?: any;
    active?: any;
    started?: any;
    doctor_fullname?: any;
    division_name?: any;
  };

  buttonLoadCheck?: any;
  errorMessage?: any;

  autoCheckInOnSave?: boolean;
};

export const DiagnosisStateInitial = {
  selectorMode: false,
  clinicalFindingIndex: null,
  doctorProfileData: {},
  openModCancelTreatmentPlan: {
    open: false,
  },
  // openGallery: {
  //   open: false,
  //   activeTabs: [],
  //   imageOverlayData: [],
  //   hideBabyTooth: false,
  // },
  showDrawingChecked: [],
  showDrawingCheckedAll: false,
  // editRow: null,
  openModRemoveClinicalFinding: {
    open: false,
    id: null,
    title: "",
  },
  muscleExamData: {},
  softTissueExamData: {},
  faceExamData: {},
  dentalExamData: {},
  periodontalExamData: {},
  medicalHistoryList: {
    id: null,
    edit_user: "",
    created: "",
    edited: "",
    encounter: null,
    chief_complaints: "",
    present_illness: "",
    additional_comment: "",
    active: "",
    started: "",
    doctor_fullname: "",
    division_name: "",
  },
};

export const medicalHistoryListInitial = {
  id: null,
  edit_user: "",
  created: "",
  edited: "",
  encounter: null,
  chief_complaints: "",
  present_illness: "",
  additional_comment: "",
  active: "",
  started: "",
  doctor_fullname: "",
  division_name: "",
};

export type DiagnosisEvent =
  | { message: "handleSetTemplateChiefComplaintShortcut"; params: { event: any; keyType: string } }
  | { message: "SaveDiagnosis"; params: {} }
  | { message: "SaveClinicalFindingById"; params: { id: string; card: string; image?: any; imageId?: any; btnAction?: string; saveTreatment?: boolean } }
  | { message: "RemoveClinicalFinding"; params: {} }
  | { message: "ToggleClinicalTags"; params: { name: string; diagram: string } }
  | { message: "SaveKeyboardShortcut"; params: { data: any[] } }
  | { message: "DeleteKeyboardShortcut"; params: {} }
  | { message: "SetKeyboardShortcutToClinicalFinding"; params: { event: any; clinicalFindingIndex: number } }
  | { message: "SetOpenModalDrawing"; params: { location: string; organ: any[]; data: any[]; row: any } }
  | { message: "SetToggleShowDrawingOverlay"; params: { row: any } }
  | { message: "SetToggleShowDrawingAll"; params: { checked: boolean; data: any } }
  | { message: "SaveDrawingOverlay"; params: { data: any; row: any } }
  | { message: "SetCheckedMuscleExam"; params: {} }
  | { message: "SetCheckedSoftTissueExam"; params: {} }
  | { message: "SetCheckedFaceExam"; params: {} }
  | { message: "SetCheckedDentalExam"; params: {} }
  | { message: "SetCheckedPeriodontalExam"; params: {} }
  | { message: "SetPatientSpecialTooth"; params: {} }
  | { message: "GetReExaminationEncounter" }
  | { message: "GetMedicalHistoryByEncounter"; params: {} }
  | { message: "SetCloseOpenGallery"; params: {} };

type Handler = WasmHandler<DiagnosisState, DiagnosisEvent>;

export const handleSetTemplateChiefComplaintShortcut: Handler = (controller, params) => {
  const state = controller.getState();

  if (params.event.keyCode >= 112 && params.event.keyCode <= 123) {
    params.event.preventDefault();

    const shortcut = state.doctorProfileData.keyboardshortcut?.find((item: any) => item?.key === params.event.key && item.key_type === params.keyType);

    if (shortcut) {
      let result: string = "";
      if (state.medicalHistoryList?.[params.event?.target?.name]) {
        result = state.medicalHistoryList[params.event?.target?.name] + " ";
      }
      result += shortcut.other_clinical_finding;

      controller.setState({
        medicalHistoryList: {
          ...state.medicalHistoryList,
          [params.event.target.name]: result,
        },
      });
    }
  }
};

export const SetMedHistory: Handler = async (controller, params) => {
  const state = controller.getState();
  console.log("SaveDiagnosis state: ", state);

  const medicalHistoryList = state.medicalHistoryList;
  controller.setState({ isMainLoading: true });

  let dmh = await DentalMedicalHistoryApproveDetail.update({
    apiToken: controller.apiToken,
    pk: medicalHistoryList?.id || params.medicalHistoryListId,
    data: {
      approve_status: params.approveStatus,
      ...(!state?.userPosition?.student_flag && { approved_by: state.userProfile?.doctor }),
    },
    extra: {
      division: state.django?.division?.id,
    },
  });

  if (dmh?.[1]) {
    controller.setState({
      isMainLoading: false,
      openModMessage: true,
      messageTitle: "บันทึกไม่สำเร็จ",
      errorMessage: dmh?.[1],
    });
    return;
  } else {
    // console.log("SaveDiagnosis update: ", r);
    controller.setState({
      isMainLoading: false,
      openModMessage: true,
      messageTitle: "บันทึกสำเร็จ",
      errorMessage: null,
    });
  }

  // controller.handleEvent({ message: "GetPatientDetailByQueue", params: { id: state.encounterInfo.patient, encounterId: state.encounterInfo.id } });
  // controller.handleEvent({ message: "handleRefreshQueue" });
};

export const SaveDiagnosis: Handler = async (controller, params) => {
  const state = controller.getState();
  console.log("SaveDiagnosis state: ", state);

  if (Number.isInteger(state.encounterIndex)) {
    const { id, ...data } = state.encounterList[state.encounterIndex];
    const medicalHistoryList = state.medicalHistoryList;
    // console.log("SaveDiagnosis Id: ", id, params);
    console.log("SaveDiagnosis Data", data);
    // console.log("SaveDiagnosis encounterList", state.encounterList[state.encounterIndex]);
    // TODO: Need Binding API / Check logic
    // controller.db.collection("Encounter").doc(state.encounterList[state.encounterIndex].id).update(data);
    if (medicalHistoryList?.id === null || medicalHistoryList?.id === undefined) {
      const [r, e, n] = await DentalMedicalHistoryList.create({
        apiToken: controller.apiToken,
        data: {
          encounter: id,
          chief_complaints: medicalHistoryList.chief_complaints,
          present_illness: medicalHistoryList.present_illness,
          additional_comment: medicalHistoryList.additional_comment,
          division_name: data.division_name,
          doctor_fullname: data.doctor_name,
          started: formatDate(moment()),
          ...(!state?.userPosition?.student_flag && { approved_by: state.userProfile?.doctor }),
        },
        extra: {
          division: state.django?.division?.id,
        },
      });
      if (e) {
        controller.setState({
          isMainLoading: false,
          openModMessage: true,
          messageTitle: "บันทึกไม่สำเร็จ",
          errorMessage: e,
        });
        console.log(n);
        return;
      }

      controller.setState({
        isMainLoading: false,
        openModMessage: true,
        messageTitle: "บันทึกสำเร็จ",
        errorMessage: null,
        medicalHistoryList: {
          ...state.medicalHistoryList,
          id: r.id,
        },
      });

      // console.log("SaveDiagnosis: ", r);
    } else {
      // console.log("SaveDiagnosis Update medicalHistory", params.id);
      controller.setState({ isMainLoading: true });
      const [r, e, n] = await DentalMedicalHistoryDetail.patch({
        apiToken: controller.apiToken,
        pk: medicalHistoryList.id,
        data: {
          encounter: id,
          chief_complaints: medicalHistoryList.chief_complaints,
          present_illness: medicalHistoryList.present_illness,
          additional_comment: medicalHistoryList.additional_comment,
          ...(!state?.userPosition?.student_flag && { approved_by: state.userProfile?.doctor }),
        },
        extra: {
          division: state.django?.division?.id,
        },
      });

      if (e) {
        controller.setState({
          isMainLoading: false,
          openModMessage: true,
          messageTitle: "บันทึกไม่สำเร็จ",
          errorMessage: e,
        });
        return;
      } else {
        // console.log("SaveDiagnosis update: ", r);
        controller.setState({
          isMainLoading: false,
          openModMessage: true,
          messageTitle: "บันทึกสำเร็จ",
          errorMessage: null,
        });
      }
    }

    // รับเข้าตรวจอัตโนมัติตอน save (เปิดด้วย autoCheckInOnSave)
    if (state.autoCheckInOnSave && ["TRANSFER_OR", "WAIT_TRIAGE", "ARRIVING", "SCREENED", "ARRIVED", "IN_QUEUE"].includes(data?.status)) {
      controller.handleEvent({ message: "handleCheckin", params: {type: data.type} });
    }
  }
};

export const SetCloseOpenGallery: Handler = (controller) => {
  controller.setState({
    openGallery: {
      open: false,
      activeTabs: [],
      imageOverlayData: [],
      hideBabyTooth: false,
    },
    clinicalFindingIndex: null,
    clinicalFindingId: null,
  });
};

const CheckPatientSpecialTooth: Handler = (controller, params) => {
  const state = controller.getState();
  if (params.implant) {
    let implantLocation =
      state.clinicalFindingList
        ?.filter((obj) => obj.clinicaltags?.split(",").filter((o) => o.trim() === "Implant").length > 0)
        .map((item) => item.locations_name?.split(",").map((o) => o.trim()))
        .join(",")
        .split(",") || [];

    // console.log(" implantLocation", implantLocation)
    implantLocation = getOnlyFullTeeth(implantLocation, controller.data.organ.items);
    // console.log("getTeeth implantLocation", implantLocation)
    if (implantLocation.length > 0) {
      implantLocation = implantLocation.map((item) => item.nickName).filter((item) => !item.startsWith("S"));
      return state.patientDetail?.implantteeth?.filter((item) => implantLocation.includes(item.nickName));
    }
  }
  if (params.missing) {
    let missingLocation =
      state.clinicalFindingList
        ?.filter((obj) => obj.clinicaltags?.split(",").filter((o) => MissingToothClinical.includes(o.trim())).length > 0)
        .map((item) => item.locations_name?.split(",").map((o) => o.trim()))
        .join(",")
        .split(",") || [];
    console.log("SaveClinicalFindingById CheckPatientSpecialTooth missingLocation: ", missingLocation);
    missingLocation = getOnlyFullTeeth(missingLocation, controller.data.organ.items);
    console.log("SaveClinicalFindingById CheckPatientSpecialTooth missingLocation: ", missingLocation);
    if (missingLocation.length > 0) {
      missingLocation = missingLocation.map((item) => item.nickName);
      return state.patientDetail?.missingteeth?.filter((item) => missingLocation.includes(item.nickName));
    }
  }
  return [];
};

const findCompleteToothOfSpecial: Handler = (controller, params) => {
  const state = controller.getState();
  const completeToothData = controller.data.organ.items
    .filter((item) => item.tissue === "tooth")
    .filter((item) => item.secondary?.length === 5 || item.id?.startsWith("supertooth"));
  // console.log('SaveClinicalFindingById completeToothData: ', controller.data.organ.items, completeToothData);
  if (params.partialmissing) {
    let partialLocation =
      state.clinicalFindingList
        ?.filter((obj) => obj.clinicaltags?.split(",").filter((o) => PartialMissingToothClinical.includes(o.trim())).length > 0)
        .map((item) => item.locations_name?.split(",").map((o) => o.trim()))
        .join(",")
        .split(",") || [];
    // console.log('SaveClinicalFindingById CheckPatientSpecialTooth partialLocation: ', partialLocation);
    partialLocation = getOnlyFullTeeth(partialLocation, controller.data.organ.items);
    // console.log('SaveClinicalFindingById CheckPatientSpecialTooth partialLocation: ', partialLocation);
    if (partialLocation.length > 0) {
      partialLocation = partialLocation.map((item) => item.nickName);
      // console.log('SaveClinicalFindingById partialLocation: ', partialLocation);
      // let prepareMiss = state.patientDetail?.missingteeth?.filter(item => partialLocation.includes(item.nickName))
      // console.log("SaveClinicalFindingById compare prepareMiss", prepareMiss)
      let preparePartial = partialLocation.map((missing) =>
        completeToothData.find((master) => master.primary === missing || (missing.startsWith("S") && master.nickName === missing))
      );
      // console.log("SaveClinicalFindingById compare prepareMiss2", prepareMiss2)
      return preparePartial;
    }
  }

  if (params.implant) {
    let implantLocation =
      state.clinicalFindingList
        ?.filter((obj) => obj.clinicaltags?.split(",").filter((o) => o.trim() === "Implant").length > 0)
        .map((item) => item.locations_name?.split(",").map((o) => o.trim()))
        .join(",")
        .split(",") || [];

    // console.log(" implantLocation", implantLocation)
    implantLocation = getOnlyFullTeeth(implantLocation, controller.data.organ.items);
    // console.log("getTeeth implantLocation", implantLocation)
    if (implantLocation.length > 0) {
      implantLocation = implantLocation.map((item) => item.nickName).filter((item) => !item.startsWith("S"));

      // let prepareImpl = state.patientDetail?.implantteeth?.filter(item => implantLocation.includes(item.nickName))
      // console.log(" implantLocation", implantLocation)
      // console.log(" prepare", prepareImpl)

      let prepareImpl = implantLocation.map((implant) => completeToothData.find((master) => master.primary === implant));
      return prepareImpl;
    }
  }
  if (params.missing) {
    let missingLocation =
      state.clinicalFindingList
        ?.filter((obj) => obj.clinicaltags?.split(",").filter((o) => MissingToothClinical.includes(o.trim())).length > 0)
        .map((item) => item.locations_name?.split(",").map((o) => o.trim()))
        .join(",")
        .split(",") || [];
    // console.log('SaveClinicalFindingById CheckPatientSpecialTooth missingLocation: ', missingLocation);
    missingLocation = getOnlyFullTeeth(missingLocation, controller.data.organ.items);
    // console.log('SaveClinicalFindingById CheckPatientSpecialTooth missingLocation: ', missingLocation);
    if (missingLocation.length > 0) {
      missingLocation = missingLocation.map((item) => item.nickName ?? "");
      // console.log('SaveClinicalFindingById missingLocation: ', missingLocation);
      // let prepareMiss2 = state.patientDetail?.missingteeth?.filter(item => missingLocation.includes(item.nickName))
      // console.log("SaveClinicalFindingById compare prepareMiss2", prepareMiss2)
      let prepareMiss = missingLocation.map((missing) =>
        completeToothData.find((master) => master.primary === missing || (missing.startsWith("S") && master.nickName === missing))
      );
      // console.log("SaveClinicalFindingById compare prepareMiss2", prepareMiss2)
      return prepareMiss;
    }
  }
  return [];
};

export const SetPatientSpecialTooth: Handler = (controller, params) => {
  let teethSet = getOnlyFullTeeth(params.tooth, controller.data.organ.items);
  if (params.implant) {
    teethSet = teethSet.filter((o) => !o.nickName.startsWith("S"));
  }
  return teethSet;
};
export const getMedicalHistoryByEncounter: Handler = async (controller, params) => {
  const [r, e, n] = await DentalMedicalHistoryByEncounterDetail.retrieve({
    pk: params.id,
    apiToken: controller.apiToken,
  });
  if (e) {
    console.log("----- getMedicalHistory error : ", e);
    controller.setState({ medicalHistoryList: medicalHistoryListInitial });
    return [];
  } else {
    controller.setState({ medicalHistoryList: r });
    console.log("GetMedicalHistory2", controller.getState().medicalHistoryList);
  }
};

export const SaveClinicalFindingById: Handler = async (controller, params) => {
  const state = controller.getState();

  if (params.btnAction) {
    await controller.setState({ buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" } });
  }

  // console.log('SaveClinicalFindingById params: ', params);
  const clinicalFindings: any = state.clinicalFindingList;
  let clinicalFindingsData = [...state.clinicalFindingList];
  let missingTeethSet = findCompleteToothOfSpecial(controller, { missing: true });
  console.log("SaveClinicalFindingById missingTeethSet: ", missingTeethSet, missingTeethSet.length);
  // state.patientDetail?.missingteeth || [];
  let implantTeethSet = findCompleteToothOfSpecial(controller, { implant: true });
  // console.log('SaveClinicalFindingById implantTeethSet: ', implantTeethSet);
  // console.log("SaveClinicalFindingById state.clinicalFindingList;", state.clinicalFindingList)
  let partialMissingteethSet = findCompleteToothOfSpecial(controller, { partialmissing: true });

  for (const index in clinicalFindings) {
    // console.log("SaveClinicalFindingById index:  ", index)
    if (clinicalFindings[index].id === params.id) {
      const { id, ...data } = clinicalFindings[index];
      let organItems = controller.data.organ.items;
      let clinicalItems = controller.data.clinicaltags.items;
      let icd10Items = controller.data.icd10.items;
      let termItems = [...(controller.data.condition?.items || []), ...(controller.data.academicdx?.items || [])];

      // console.log("SaveClinicalFindingById clinicalFinding with index: ", index, clinicalFindings[index])
      let locationList = clinicalFindings[index].locations_name
        ?.split(",")
        .map((item) => item.trim())
        .filter((item) => item !== "");
      // console.log("SaveClinicalFindingById locationList", locationList);

      if (
        !clinicalFindings[index].clinicaltags ||
        clinicalFindings[index].clinicaltags.split(",").filter((o) => MissingToothClinical.includes(o.trim())).length === 0
      ) {
        let absenceTooth = clinicalFindings
          .filter((item) => item.clinicaltags && item.clinicaltags.split(",").filter((o) => MissingToothClinical.includes(o.trim())).length > 0)
          .map((item) => item.locations_name.split(",").map((o) => o.trim()))
          .join(",")
          .split(",");

        if (absenceTooth.length > 0) {
          absenceTooth = getOnlyFullTeeth(absenceTooth, organItems);
          if (absenceTooth.length > 0) {
            absenceTooth = deTinyLocation2(
              absenceTooth.map((item) => item.nickName),
              organItems
            );
            console.log("Absence tooth:", absenceTooth);
            locationList = deTinyLocation2(locationList, organItems);
            locationList = locationList.filter((t) => !absenceTooth.includes(t));
          }
        }
      }

      console.log("SaveCliniccalFindingById exclude in absence:", locationList);
      let tidyLocationList = [];
      if (locationList && locationList.length > 0) {
        tidyLocationList = tidyLocation2(locationList, organItems);
      }

      console.log("SaveCliniccalFindingById tidyLocationList: ", tidyLocationList.join(", "));
      clinicalFindingsData = clinicalFindingsData.map((examination) => {
        return examination.id === params.id
          ? { ...examination, locations_name: tidyLocationList.join(", "), clinicaltags: data.clinicaltags?.replace(/,$/, "") }
          : examination;
      });
      controller.setProp(`clinicalFindings.${index}.locations_name`, tidyLocationList.join(", "));
      data.locations_name = tidyLocationList.join(", ");
      let subTooth = "";
      data.locations_name?.split(",").forEach((item) => {
        if (isTooth(item.trim())) {
          let childTooths = getAllChildren(item.trim(), organItems)
            .map((item) => {
              let superTooth = organItems.find((o) => o.nickName === item);
              if (superTooth) {
                return superTooth.fullName;
              }
              return item;
            })
            .join(", ");
          if (subTooth.length === 0) {
            subTooth = childTooths;
          } else {
            subTooth = subTooth + ", " + childTooths;
          }
        } else {
          if (subTooth.length === 0) {
            subTooth = item.trim();
          } else {
            subTooth = subTooth + ", " + item.trim();
          }
        }
      });
      console.log("SaveClinicalFindingById allSubTooth:", subTooth);
      console.log("SaveClinicalFindingById Data for set:", data, params);
      data.locations_name = subTooth;
      //Process to get clinical id
      if (data.clinicaltags && data.clinicaltags.length > 0) {
        let clinicalSet: string[] = data.clinicaltags.split(",").map((item) => item.trim());

        // let clinicalIds = clinicalItems.filter((item) => clinicalSet.includes(item.name)).map((item) => item.id);
        let clinicalIds = clinicalSet.flatMap((value) => {
          const data = clinicalItems.find((item: any) => item.name === value);
          return data ? [data.id] : [];
        });

        data.clinical_findings = clinicalIds;
      }

      if (data.icd10_label && data.icd10_label.length > 0) {
        let icd10 = icd10Items.find((item: any) => item.icd10_label.trim() === data.icd10_label.trim());
        data.icd10 = icd10?.id || null;
        data.icd10_label = icd10?.icd10_label || "";

        clinicalFindingsData = clinicalFindingsData.map((examination) => {
          return examination.id === params.id ? { ...examination, icd10: icd10?.id || null, icd10_label: icd10?.icd10_label || "" } : examination;
        });
      }

      if (data.medical_description) {
        const term = termItems.find((item: any) => item.term.trim() === data.medical_description.trim())?.term || "";

        data.medical_description = term;

        clinicalFindingsData = clinicalFindingsData.map((examination) => {
          return examination.id === params.id ? { ...examination, medical_description: term } : examination;
        });
      }

      const [r, e, n] = await DentalExaminationDetail.update({
        pk: params.id,
        apiToken: controller.apiToken,
        data,
      });

      if (e) {
        controller.setState({
          errorMessage: { ...state.errorMessage, [params.card]: e },
        });

        return;
      } else {
        if (data.for_supernumerary_tooth) {
          controller.handleEvent({ 
            message: "GetSuperToothList", 
            params: { encounter: data.encounter } 
          });
        }
      }

      // controller.db.collection("ClinicalFinding").doc(params.id).set(data);
      if (params.image) {
        clinicalFindingsData = clinicalFindings.map((clinical) => {
          return clinical.id === params.id
            ? { ...clinical, image: Object.keys(params.image)[0] ? params.image : null, imageId: Object.keys(params.imageId)[0] ? params.imageId : null }
            : clinical;
        });
        // controller.setState({ clinicalFindingList: clinicalFindingsData });
      }

      const treatmentPlanErrors: any[] = [];

      if (params.saveTreatment) {
        let treatmentLabel = state.treatmentPlanList
          .filter((item) => item.examination === params.id)
          .filter((item) => item.status !== "X")
          .map((item) => {
            return "[" + item.treatment + "] " + item.treatment_label;
          })
          .join(", ");


        for (const treatmentPlan of state.treatmentPlanList) {
          if (treatmentPlan.examination === params.id && treatmentPlan.status !== "X") {
            const error = await controller.handleEvent({ message: "SaveTreatmentPlan", params: {...treatmentPlan, card: params.card }});

            treatmentPlanErrors.push(error);
          }
        }

        clinicalFindingsData = clinicalFindings.map((clinical) => {
          return clinical.id === params.id
            ? {
                ...clinical,
                id: params.id,
                dental_treatment_plan_label: treatmentLabel,
              }
            : clinical;
        });
        // controller.setState({
        //   clinicalFindingList: exam,
        // });
      }

      const isTreatmentPlanSuccess = params.saveTreatment && !treatmentPlanErrors.some((error) => error);

      // console.log("SaveClinicalFindingById setMissingteeth", missingTeethSet)
      // console.log(" saveExamination 1.5 ")
      controller.setState({
        clinicalFindingList: clinicalFindingsData,
        patientDetail: {
          ...state.patientDetail,
          missingteeth: missingTeethSet,
          partialmissingteeth: partialMissingteethSet,
          implantteeth: implantTeethSet,
        },
        ...(isTreatmentPlanSuccess && { showClinicalFindingsDetail: false, clinicalFindingIndex: null }),
      });

      if (missingTeethSet.toString() !== state.patientDetail.missingteeth.toString()) {
        controller.handleEvent({ message: "RecalPlaqueBleed", params: {} });
      }
    } else {
      // console.error(" no have new data ")
    }
  }

  controller.setState({ buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null } });
};

export const RemoveClinicalFinding: Handler = async (controller, params) => {
  console.log("Check remove:", { ...params, active: false });
  const state = controller.getState();
  const [r, e, n] = await DentalExaminationDetailM.delete({
    pk: params.id,
    apiToken: controller.apiToken,
  });
  if (e) {
    console.log("Can not remove examination:", e);
    return;
  } 

  if (params.for_supernumerary_tooth) {
    controller.handleEvent({ 
      message: "GetSuperToothList", 
      params: { encounter: params.encounter } 
    });
  }

  console.log("remove examination complete");
  // props.setProp("openModRemoveClinicalFinding", { open: false, id: null, title: "" });
  controller.setState({
    clinicalFindingList: state.clinicalFindingList.filter((item) => item.id !== params.id),
    filterClinicalFindingIds: state.filterClinicalFindingIds.filter((item) => item !== params.id),
    openModRemoveClinicalFinding: DiagnosisStateInitial.openModRemoveClinicalFinding,
  });
};


export const ToggleClinicalTags: Handler = (controller, params) => {
  const state = controller.getState();
  console.log(
    "ToggleClinicalTags !!! ! !! ! ! ! state.clinicalFindingIndex: ",
    state.clinicalFindingIndex,
    "state.clinicalFindingList[state.clinicalFindingIndex]: ",
    state.clinicalFindingList[state.clinicalFindingIndex],
    "params: ",
    params
  );

  // const organItems = controller.data.organ.items
  let clinicalTags = [];
  if (state.clinicalFindingList[state.clinicalFindingIndex].clinicaltags) {
    clinicalTags = state.clinicalFindingList[state.clinicalFindingIndex].clinicaltags?.split(",");
  }
  clinicalTags = clinicalTags.map((item) => item.trim());

  let isParentSelected = false;
  let list = {};

  // Get Main Type
  if (controller.data?.clinicaltags?.items) {
    let tags = controller.data?.clinicaltags?.items;
    if (params.diagram === "teeth") {
      tags = tags.filter((item) => item.diagram === "teeth");
    } else {
      tags = tags.filter((item) => item.diagram !== "teeth");
    }
    let groups = tags.filter((item) => !item.detail);
    groups.forEach((group) => {
      // console.log("element ", group);
      let detail = tags
        .filter((item) => item.group === group.name)
        // .filter((item) => item.detail)
        .map((item) => {
          return { ...item };
        });

      // console.log("detail ", detail);
      list[group.name] = detail;
    });
    isParentSelected = groups.filter((item) => item.name === params.name)?.length > 0;
  }

  console.log("ToggleClinicalTags list: ", list);
  // Add or Remove.
  // parent selected / unselected with remove along child.

  if (params.diagram === "teeth") {
    // teeth
    /*************************** Teeth ***************************/
    if (clinicalTags.includes(params.name)) {
      if (isParentSelected) {
        clinicalTags = clinicalTags.filter((item) => {
          let isHave = list[params.name].find((li) => li.name === item);
          // console.log(" list[params.name]: ", list[params.name] , "isHave", isHave)
          return !isHave;
        });
      }
      // remove
      clinicalTags = clinicalTags.filter((item) => item !== params.name);
    } else {
      // add
      if (isParentSelected) {
        // console.log("Add with isParentSelected = true , clinicalTags: ", clinicalTags, " list: ", list)
        clinicalTags = clinicalTags.filter((item) => {
          let isHave = list[params.name].find((li) => li.name === item);
          // console.log(" list[params.name]: ", list[params.name] , "isHave", isHave)
          return !isHave;
        });
        // console.log(" Check clinicalTags:", clinicalTags)
      }
      // add
      clinicalTags = clinicalTags.concat(params.name);
    }
  } else {
    // noteeth
    /*************************** No Teeth ***************************/

    if (clinicalTags.includes(params.name)) {
      clinicalTags = clinicalTags.filter((item) => item !== params.name);
    } else {
      let sumName = "";
      let sumList = [];
      for (const key in list) {
        if (Object.prototype.hasOwnProperty.call(list, key)) {
          if (key.includes("&")) {
            sumName = key;
          } else {
            sumList.push(key);
          }
        }
      }

      if (clinicalTags.includes(sumName) && params.name !== sumName) {
        // กดตัวอื่น เอา sum ออก
        const index = clinicalTags.indexOf(sumName);
        if (index > -1) {
          clinicalTags.splice(index, 1);
        }
      } else if (params.name === sumName && !clinicalTags.includes(sumName)) {
        // กด Sum เอาตัวอื่นออก
        sumList.forEach((item) => {
          const index = clinicalTags.indexOf(item);
          if (index > -1) {
            clinicalTags.splice(index, 1);
          }
        });
      }

      // add
      clinicalTags.push(params.name);

      // ถ้า มีลูกทั้งคู่ เอาออกแล้ว ใส่ sum
      let isContainBoth = true;
      sumList.forEach((item) => {
        if (!clinicalTags.includes(item)) {
          isContainBoth = false;
        }
      });

      if (isContainBoth) {
        sumList.forEach((item) => {
          const index = clinicalTags.indexOf(item);
          if (index > -1) {
            clinicalTags.splice(index, 1);
          }
        });
        clinicalTags.push(sumName);
      }
      console.log("clinicalTags", clinicalTags);
    }
  }

  clinicalTags = clinicalTags.filter((item) => item !== "");
  console.log("ToggleClinicalTags !!!!!! clinicalTags", clinicalTags);
  controller.setProp(`clinicalFindingList.${state.clinicalFindingIndex}.clinicaltags`, clinicalTags.join(" ,"));
};

export const SaveKeyboardShortcut: Handler = async (controller, params) => {
  const { doctorProfileData, django } = controller.getState();
  let shortcutKeys = [];
  for (const keyItem of Object.keys(params.data)) {
    //check then update
    if (params.data[keyItem].id) {
      let checkItem = doctorProfileData.keyboardshortcut.find((item: any) => item.id === params.data[keyItem].id);
      console.log(checkItem, params.data[keyItem].value);
      if (checkItem.other_clinical_finding !== params.data[keyItem].value || checkItem.key !== keyItem) {
        const [r, e, n] = await DentalClinicalFindingHotKeyDetail.update({
          pk: checkItem.id,
          apiToken: controller.apiToken,
          data: {
            key: keyItem,
            other_clinical_finding: params.data[keyItem].value,
            user: django.user.id,
          },
        });
        if (e) {
          console.log("Update shortcut Fail");
        } else {
          shortcutKeys.push(r);
        }
      } else {
        shortcutKeys.push(checkItem);
      }
    } else {
      const [r, e, n] = await DentalClinicalFindingHotKeyList.create({
        apiToken: controller.apiToken,
        data: {
          key: keyItem,
          other_clinical_finding: params.data[keyItem].value,
          user: django.user.id,
          key_type: params.key_type,
        },
      });
      if (e) {
        console.log("Create Shortcut key error");
      } else {
        shortcutKeys.push(r);
      }
    }
  }

  const filterShortcut = (doctorProfileData?.keyboardshortcut || []).filter((item: any) => item.key_type !== params.key_type);
  console.log(shortcutKeys);

  controller.setState({
    doctorProfileData: {
      ...doctorProfileData,
      keyboardshortcut: [...filterShortcut, ...shortcutKeys],
    },
  });
};

export const DeleteKeyboardShortcut: Handler = async (controller, params) => {
  // const [r, e, n] = await
  const { doctorProfileData, django } = controller.getState();
  const shortcutIds: any[] = [];
  for (const item of params.data) {
    console.log(item);
    const [r, e, n] = await DentalClinicalFindingHotKeyDetail.update({
      pk: item.id,
      apiToken: controller.apiToken,
      data: {
        key: item.key,
        active: false,
        user: django.user.id,
      },
    });
    if (e) {
      console.log("Update shortcut Fail");
    } else {
      shortcutIds.push(item.id);
    }
  }
  controller.setState({
    doctorProfileData: {
      ...doctorProfileData,
      keyboardshortcut: doctorProfileData.keyboardshortcut.filter((item: any) => !shortcutIds.includes(item.id)),
    },
  });
};

export const SetKeyboardShortcutToClinicalFinding: Handler = (controller, params) => {
  const { event, clinicalFindingIndex } = params;
  const { doctorProfileData, clinicalFindingList } = controller.getState();

  console.log(doctorProfileData, clinicalFindingList);
  if (event.keyCode >= 112 && event.keyCode <= 123) {
    event.preventDefault();
    const shortcut = doctorProfileData.keyboardshortcut?.find((item: any) => item?.key === event.key && item.key_type === "EX");

    if (shortcut) {
      const cloneArr = [...(clinicalFindingList || [])];
      cloneArr[clinicalFindingIndex].other_clinical_finding = `${event.target.value}${shortcut.other_clinical_finding}`;
      controller.setState({
        clinicalFindingList: cloneArr,
      });
    }
  }
};

export const SetOpenModalDrawing: Handler = (controller, params) => {
  console.log(params);
  const { location, organ: organs, data, row, clinicalFindingList } = params;
  const { patientDetail } = controller.getState();

  let splitLocation = location.split(",")?.map((item) => item.trim());
  const tissue = ["tooth", "face", "muscle", "soft", "jaw", "odontogram"];
  const hashMap = new Map();

  const imageOverlayData = [...clinicalFindingList].map((clinical) => {
    return clinical.id !== row.id
      ? {
          ...clinical,
          remove_on_save: true,
        }
      : clinical;
  });

  const filterLocation = splitLocation?.reduce((result, item) => {
    const find = organs.find((organ) => organ.nickName === item);
    if (find) {
      const key = (find.settingKey || find.tissue).replace(/[\d]+/g, "");
      if (tissue.includes(key)) {
        result.push(key);
      }
    }
    return result;
  }, []);

  console.log("Image Over Lay: ", imageOverlayData);
  controller.setState({
    openGallery: {
      open: true,
      activeTabs: filterLocation,
      imageOverlayData: imageOverlayData,
      hideBabyTooth: patientDetail?.hideBabyTooth,
    },
    clinicalFindingList: clinicalFindingList,
  });
};

export const SetToggleShowDrawingOverlay: Handler = (controller, params) => {
  const { showDrawingChecked, clinicalFindingList } = controller.getState();
  const { row } = params;
  const cloneArr = [...showDrawingChecked];
  const findIndex = cloneArr?.findIndex((item) => item === row.id);
  if (findIndex === -1) {
    cloneArr.push(row.id);
  } else {
    cloneArr.splice(findIndex, 1);
  }

  console.log(cloneArr);
  controller.setState({
    showDrawingChecked: cloneArr,
    showDrawingCheckedAll: cloneArr.length === clinicalFindingList.length ? true : false,
  });
  // if(){
  //   cloneArr[activeIndexDiagram]
  // }
};

export const SetToggleShowDrawingAll: Handler = (controller, params) => {
  const { checked, data } = params;
  const { showDrawingChecked } = controller.getState();
  let cloneShowDrawing = [...showDrawingChecked];
  if (checked) {
    cloneShowDrawing = data.map((item) => item.id);
  } else {
    cloneShowDrawing.length = 0;
  }

  controller.setState({
    showDrawingCheckedAll: checked,
    showDrawingChecked: cloneShowDrawing,
  });
};

export const SaveDrawingOverlay: Handler = async (controller, params) => {
  const { clinicalFindingId, clinicalFindingList } = controller.getState();
  let examinationData = clinicalFindingList.filter((item) => clinicalFindingId === item.id)[0];

  const tissueImageList = Object.keys(params.data);
  const removeImageList = [];
  if (tissueImageList.length !== 0) {
    let image: any = {};
    let imageId: any = {};
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: "Token " + controller.apiToken,
      },
    };
    console.log(tissueImageList);
    for (const list of tissueImageList) {
      const formData = new FormData();
      formData.append("image", params.data[list].image_file);
      formData.append("tissue_name", (tissueMapPane as any)[list]);
      formData.append("examination", clinicalFindingId);
      let res = null;

      if (examinationData.imageId && examinationData.imageId[list]) {
        if (params.data[list].fully_transparent) {
          formData.append("active", "false");
        } else {
          formData.append("active", "true");
        }

        res = await axios.patch(`${HOST}/apis/DEN/examination-image/${examinationData.imageId[list]}/`, formData, config);
      } else {
        res = await axios.post(`${HOST}/apis/DEN/examination-image/`, formData, config);
      }

      const path = res.data.image;

      console.log(res);
      image[list] = path;
      imageId[list] = res.data.id;

      if (!res.data.active && image[list]) {
        removeImageList.push(list);
      }
    }

    console.log(image, imageId);
    const findClinical = clinicalFindingList.find((clinical) => clinical.id === clinicalFindingId);
    const { image: prevImage = {}, imageId: prevImageId = {} } = findClinical;
    image = {
      ...prevImage,
      ...image,
    };
    imageId = {
      ...prevImageId,
      ...imageId,
    };

    removeImageList.forEach((key) => {
      delete image[key];
      delete imageId[key];
    });

    SaveClinicalFindingById(controller, { id: clinicalFindingId, image, imageId });
  }
};

export const SetCheckedMuscleExam: Handler = (controller, params) => {
  const { muscleExamData } = controller.getState();

  const data = SetCheckedExam(controller, {
    ...params,
    data: muscleExamData,
    defaultData: MUSCLE_EXAM_DATA,
  });

  controller.setState({
    muscleExamData: data,
  });
};

export const SetCheckedSoftTissueExam: Handler = (controller, params) => {
  if (!SOFT_TISSUE_EXAM_DATA?.salivaryglands1) {
    const keyList = ["salivaryglands", "libs", "labialMucosa", "buccalMucosa", "palate", "tongue", "floorMouth", "oropharynx"];

    const softTissue: any = createKeyAbNormal(keyList);

    softTissue.numericalRating1 = {
      value: "",
    };
    SOFT_TISSUE_EXAM_DATA = softTissue;
  }

  const { softTissueExamData } = controller.getState();

  const data = SetCheckedExam(controller, {
    ...params,
    data: softTissueExamData,
    defaultData: SOFT_TISSUE_EXAM_DATA,
  });

  controller.setState({
    softTissueExamData: data,
  });
};
//
export const SetCheckedPeriodontalExam: Handler = (controller, params) => {
  if (!PERIODONTAL_EXAM_DATA?.gingivalContore1) {
    const keyList = ["gingivalContore", "gingivalColor", "gingivalTexture", "toothMobility", "pocket", "bleeding", "recession"];

    const periodontal: any = createKeyAbNormal(keyList);

    for (const key of ["plaqueStain", "calculus"]) {
      for (let i = 1; i <= 4; i++) {
        periodontal[`${key}${i}`] = {
          value: false,
          text: "",
        };
      }
    }
    periodontal.otherFinding1 = {
      value: "",
    };
    PERIODONTAL_EXAM_DATA = periodontal;
  }

  const { periodontalExamData } = controller.getState();

  const data = SetCheckedExam(controller, {
    ...params,
    data: periodontalExamData,
    defaultData: PERIODONTAL_EXAM_DATA,
  });

  controller.setState({
    periodontalExamData: data,
  });
};

export const SetCheckedFaceExam: Handler = (controller, params) => {
  if (!FACE_EXAM_DATA?.facial1) {
    const keyList = ["facial", "skin", "lymphNode"];
    FACE_EXAM_DATA = createKeyAbNormal(keyList);
  }

  const { faceExamData } = controller.getState();
  console.log("faceExamData: ", params, faceExamData);
  const data = SetCheckedExam(controller, {
    ...params,
    data: faceExamData,
    defaultData: FACE_EXAM_DATA,
  });

  controller.setState({
    faceExamData: data,
  });
};

export const SetCheckedDentalExam: Handler = (controller, params) => {
  if (!DENTAL_EXAM_DATA?.shape1) {
    const keyList = ["shape", "color", "texture", "position"];

    const dental: any = createKeyAbNormal(keyList);

    for (const key of ["angleClassRight", "angleClassLeft"]) {
      for (let i = 1; i <= 4; i++) {
        dental[`${key}${i}`] = {
          value: false,
          text: "",
        };
      }
    }
    dental.overjet1 = {
      value: "",
    };
    dental.overbit1 = {
      value: "",
    };
    DENTAL_EXAM_DATA = dental;
  }

  const { dentalExamData } = controller.getState();

  const data = SetCheckedExam(controller, {
    ...params,
    data: dentalExamData,
    defaultData: DENTAL_EXAM_DATA,
  });

  controller.setState({
    dentalExamData: data,
  } as any);
};

export const SetCheckedExam: Handler = (controller, params) => {
  let cloneMuscle = { ...params.data };

  if (!Object.keys(cloneMuscle)[0]) {
    cloneMuscle = JSON.parse(JSON.stringify(params.defaultData));
  }

  const removeLastNumber = params.name.replace(/\d+$/i, "");
  const lastNumber = +params.name.match(/\d+$/i)[0];

  let isLoop = true;
  let i = 1;

  while (isLoop) {
    if (cloneMuscle[`${removeLastNumber}${i}`]) {
      if (typeof cloneMuscle[`${removeLastNumber}${i}`].value === "boolean") {
        cloneMuscle[`${removeLastNumber}${i}`].value = false;
      }
      if (cloneMuscle[`${removeLastNumber}${i}`].text) {
        cloneMuscle[`${removeLastNumber}${i}`].text = "";
        cloneMuscle[`${removeLastNumber}${i}`].value = "";
      }
      i++;
    } else {
      isLoop = false;
    }
  }

  if (params.input && cloneMuscle[`${removeLastNumber}${lastNumber - 1}`]) {
    cloneMuscle[`${removeLastNumber}${lastNumber - 1}`].value = true;
  }

  cloneMuscle[params.name].value = params.value;
  cloneMuscle[params.name].text = params.text;

  if (params.name) {
    return cloneMuscle;
  }

  return params.data;
};

export const GetReExaminationEncounter: Handler = async (controller, params) => {
  const state = controller.getState();

  if (state.patientDetail?.id) {
    let [response, error, network] = [null, null, null]
    if (params.sub === "examination") {
      [response, error, network] = await DentalExaminationList.list({
        apiToken: controller.apiToken,
        params: { patient: state.patientDetail.id },
      });
    } else if (params.sub === "medicalHistory") {
      [response, error, network] = await DentalMedicalHistoryList.list({
        apiToken: controller.apiToken,
        params: { patient: state.patientDetail.id },
      });
    }

    // get unique values
    const result: any[] = Array.from(new Map((response?.items || []).map((item: any) => [item.encounter, item])).values());

    controller.setState({
      openModalReExamination: true,
      reExaminationSub: params.sub,
      reExamEncounterList: result,
      allReExamEncounterList: result,
    });
  }
};

const createKeyAbNormal = (keyList: string[]) => {
  const defaultObj = {
    value: false,
    text: "",
  };
  const objKey: Record<string, any> = {};
  for (const key of keyList) {
    objKey[`${key}1`] = defaultObj;
    objKey[`${key}2`] = defaultObj;
    objKey[`${key}3`] = {
      value: "",
    };
  }

  return objKey;
};

const MUSCLE_EXAM_DATA = {
  planeScale1: {
    value: "",
  },
  jointSound1: {
    value: false,
    text: "",
  },
  jointSound2: {
    value: false,
    text: "",
  },
  jointSound3: {
    value: "",
  },
  mouthOpening1: {
    value: false,
    text: "",
  },
  mouthOpening2: {
    value: false,
    text: "",
  },
  mouthOpening3: {
    value: false,
    text: "",
  },
  mouthOpening4: {
    value: "",
  },
};

let SOFT_TISSUE_EXAM_DATA: any = {};

let FACE_EXAM_DATA: any = {};

let DENTAL_EXAM_DATA: any = {};

let PERIODONTAL_EXAM_DATA: any = {};
